// Utilities for typography
// e.x. paragraphs, autoscale labels, ....
// ================================================================================================
import { ReactNode, CSSProperties } from 'react';
import { Textfit } from 'react-textfit';
import './Typography.less';
import { isDefined } from "../../Utils/Micro";
import type { Props } from '@Utils/ReactProps';
// ================================================================================================
export interface LabelAutoSizeProps {
    Text: string | ReactNode;
    Width: number;
    Height: number;
    MaxFontSize: number;
    MultiLine?: boolean;
    Style?: CSSProperties;
}

export function LabelAutoSize(props: LabelAutoSizeProps) {
    if (isDefined(props.Text)) {
        return <div
            id='label-auto-size'
            style={{
                width: props.Width,
                height: props.Height,
                lineHeight: props.MultiLine ? undefined : props.Height + "px",
                ...props.Style
            }}>
            <Textfit
                mode={props.MultiLine ? "multi" : "single"}
                forceSingleModeWidth={false}
                max={props.MaxFontSize}
            >
                {props.Text}
            </Textfit>
        </div>
    }
    return null;
}
// ================================================================================================
export function getRowMinHeight(numRow: number, height: number, minHeight: number, totalVerticalPadding: number): number {
    let fillHeight = minHeight;
    if (numRow == 1) {
        fillHeight = height - totalVerticalPadding;
    } else {
        fillHeight = Math.floor((height - totalVerticalPadding) / numRow);
        if (fillHeight < minHeight)
            fillHeight = minHeight;
    }
    return fillHeight;
}
// ================================================================================================
export interface LabelProp extends Props {
    style?: CSSProperties
}
export function TypoLabel(props: LabelProp) {
    return <label className="typography-label" style={props.style} >{props.children}</label>;
}
// ================================================================================================